<template>
  <div v-if="appName" class="in-app-notice" role="alert">
    <p class="in-app-title">Ouvrez cette page dans votre navigateur avant de payer</p>
    <p>
      Vous êtes dans le navigateur intégré de {{ appName }}. Le paiement HelloAsso y échoue
      souvent (validation bancaire). Ouvrez la page dans
      {{ android ? 'Chrome' : 'Safari' }} pour vous inscrire.
    </p>
    <p v-if="!android" class="in-app-howto">
      Touchez le menu <strong>···</strong> en haut ou en bas de l'écran, puis
      <strong>« Ouvrir dans le navigateur »</strong>.
    </p>
    <div class="in-app-actions">
      <button v-if="android" type="button" class="btn-submit" @click="openInChrome">Ouvrir dans Chrome</button>
      <button type="button" class="btn-secondary" @click="copyLink">
        {{ copied ? 'Lien copié' : 'Copier le lien' }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { chromeIntentUrl, inAppBrowserName, isAndroid } from '@/functions/inAppBrowser'

const appName = inAppBrowserName()
const android = isAndroid()
const pageUrl = window.location.href
const copied = ref(false)

const openInChrome = () => {
  window.location.href = chromeIntentUrl(pageUrl)
}

const copyLink = async () => {
  try {
    await navigator.clipboard.writeText(pageUrl)
    copied.value = true
  } catch {
    // Presse-papiers refusé par certains navigateurs intégrés : on laisse au moins
    // l'adresse sélectionnable.
    window.prompt('Copiez ce lien puis collez-le dans votre navigateur :', pageUrl)
  }
}
</script>

<style scoped>
.in-app-notice {
  background: color-mix(in srgb, var(--color-accent, #f9a825) 15%, var(--color-bg-lighter, #fff));
  border: 2px solid var(--color-accent, #f9a825);
  color: var(--color-fg, #795548);
  border-radius: var(--radius, 8px);
  padding: 1rem 1.2rem;
  margin-bottom: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.in-app-notice p {
  margin: 0;
}

.in-app-title {
  font-weight: 600;
  font-size: 1.05rem;
}

.in-app-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 0.3rem;
}

/* Styles de boutons scopés page par page dans le projet : repris de
   EventRegistrationForm.vue pour que le composant soit lisible seul. */
.btn-submit {
  padding: 0.7rem 1.5rem;
  background: var(--color-accent, #1a3a5c);
  color: var(--color-bg, #fff);
  border: none;
  border-radius: var(--radius, 8px);
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
}

.btn-secondary {
  padding: 0.7rem 1.2rem;
  background: transparent;
  border: 1px solid var(--color-light-shadow);
  color: var(--color-fg, #333);
  border-radius: var(--radius, 8px);
  cursor: pointer;
  font-size: 0.95rem;
}
</style>
